/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_ListingInputs */

const en_share_listing = /** @type {(inputs: Share_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share Listing`)
};

const id_share_listing = /** @type {(inputs: Share_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan Listing`)
};

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const es_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const fr_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const de_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const ja_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const zh_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const ar_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const it_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const ru_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const pt_share_listing = en_share_listing;

/** @type {(inputs: Share_ListingInputs) => LocalizedString} */
const ko_share_listing = en_share_listing;

/**
* | output |
* | --- |
* | "Share Listing" |
*
* @param {Share_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const share_listing = /** @type {((inputs?: Share_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_share_listing(inputs)
	if (locale === "es") return es_share_listing(inputs)
	if (locale === "fr") return fr_share_listing(inputs)
	if (locale === "de") return de_share_listing(inputs)
	if (locale === "ja") return ja_share_listing(inputs)
	if (locale === "zh") return zh_share_listing(inputs)
	if (locale === "ar") return ar_share_listing(inputs)
	if (locale === "id") return id_share_listing(inputs)
	if (locale === "it") return it_share_listing(inputs)
	if (locale === "ru") return ru_share_listing(inputs)
	if (locale === "pt") return pt_share_listing(inputs)
	return ko_share_listing(inputs)
});